import { Button } from '@razorpay/blade/components';

import React from 'react';
import { useDispatch } from 'react-redux';
import { pastPayrollExecutionHelpLink } from '../constants';
import { useRunPayrollDataContext } from '../contexts/RunPayrollDataContext';
import { setIsSkippedCountConsentGranted } from '../contexts/runPayrollSlice';
import PayrollFinalizationAcknowledgmentModal from './PayrollFinalizationAcknowledgmentModal';
import ExecutionPendingCard from './ExecutionPendingCard';

type Props = {
  isTdsFilingConfigRequired: boolean;
  onExecutePayroll: () => void;
};

const ExecuteCard = ({
  isTdsFilingConfigRequired,
  onExecutePayroll,
}: Props): React.ReactElement | null => {
  const [isOpen, setIsOpen] = React.useState(false);
  const data = useRunPayrollDataContext();
  const dispatch = useDispatch();

  const skippedEmployees = data.skippedEmployeeCountForFY;

  // Determine if we should show simple execution button without modal

  const hasSkippedEmployees = skippedEmployees && skippedEmployees > 0;
  const autoSkippedCount = data.autoSkipCount ?? 0;
  const warningCount = data.negativeNetPayWarningCount ?? 0;
  const negativeSAWarningCount = data.negativeSAWarningCount ?? 0;
  const pfMismatchWarningCount = data.pfMismatchWarningCount ?? 0;
  const totalEmployees = autoSkippedCount + warningCount + negativeSAWarningCount + pfMismatchWarningCount;
  const hasErrorWarning = totalEmployees > 0;

  const handleRequestExecution = () => {
    if (hasErrorWarning) {
      setIsOpen(true);
      return;
    } else onExecutePayroll();
  };
  const getExecutionContent = () => {
    if (hasSkippedEmployees) {
      return (
        <>
          <ExecutionPendingCard
            skippedEmployees={skippedEmployees ?? 0}
            pastPayrollExecutionHelpLink={pastPayrollExecutionHelpLink}
            isTdsFilingConfigRequired={isTdsFilingConfigRequired}
            setIsOpen={setIsOpen}
            payrollMonth={data.payrollMonth}
          />
        </>
      );
    }

    return (
      <Button isDisabled={isTdsFilingConfigRequired} type="button" onClick={handleRequestExecution}>
        Request Execution
      </Button>
    );
  };

  return (
    <>
      {getExecutionContent()}{' '}
      <PayrollFinalizationAcknowledgmentModal
        isOpen={isOpen}
        onOpenChange={setIsOpen}
        onCancel={() => setIsOpen(false)}
        onExecute={() => {
          dispatch(setIsSkippedCountConsentGranted(true));
          setIsOpen(false);
          onExecutePayroll();
        }}
      />
    </>
  );
};

export default ExecuteCard;
